import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Guarantee() {
  return <section className="border-y border-white/10 bg-charcoal px-5 py-14 md:px-8" data-id="element-85">
      <FadeIn className="mx-auto max-w-3xl border border-accent/40 bg-ink p-7 text-center md:p-10" data-id="element-86">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-accent/40 text-accent" data-id="element-87">
          <ShieldCheckIcon size={29} strokeWidth={1.5} aria-hidden="true" data-id="element-88" />
        </div>
        <p className="mt-5 text-sm font-bold uppercase tracking-[0.18em] text-accent" data-id="element-89">
          Garantía CONVERSION ELITE™
        </p>
        <h2 className="mt-2 font-display text-3xl font-bold text-white md:text-4xl" data-id="element-90">
          Tenés 7 días para decidir.
        </h2>
        <div className="mx-auto mt-5 max-w-xl space-y-3 text-sm leading-relaxed text-stone-300 md:text-base" data-id="element-91">
          <p data-id="element-92">Explorá los 6 módulos. Revisá los 4 bonos. Utilizá el material.</p>
          <p data-id="element-93">
            Si dentro de los primeros 7 días considerás que no cumple con tus
            expectativas, te devolvemos el dinero.
          </p>
          <p className="font-semibold text-accent" data-id="element-94">
            Sin preguntas. Sin complicaciones.
          </p>
        </div>
      </FadeIn>
    </section>;
}